import React from "react";

import Button from "../Button";
import ButtonMutation from "../ButtonMutation";

const StyledButtonMutation = (props) => <ButtonMutation ButtonComponent={Button} {...props} />;

export default StyledButtonMutation;
